module.exports = __webpack_public_path__ + "img/putong_431008.a30e8d74.jpg";